<template>

    <title-card :title="title" :side-icon="icon" :help="help">

        <v-card v-if="debug">
            <v-card-text>
                <div>TimeStamp: {{timestamp}}</div>
                <div>PickerDate: {{ pickerDate }}</div>
                <div>ComputedDate: {{ computedDate }}</div>
                <div>PickerTime: {{ pickerTime }}</div>
                <div>ComputedTime: {{ computedTime }}</div>
                <div>Min: {{ min }}</div>
                <div>Max: {{ max }}</div>
            </v-card-text>
        </v-card>

        <date-picker-field v-model="pickerDate"
                           :min="min"
                           :max="max"
                           @input="saveDate"
        ></date-picker-field>

        <v-menu v-if="!disableTime"
                :close-on-content-click="false"
                ref="timeMenu"
                v-model="timeMenuOpen"
                :nudge-right="40"
                :return-value.sync="pickerTime"
                transition="scale-transition"
                offset-y
                max-width="450px"
                min-width="290px"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                        v-model="computedTime"
                        label="Time"
                        prepend-icon="mdi-clock-outline"
                        readonly
                        :error-messages="errorMessages"
                        v-on="on"
                ></v-text-field>
            </template>

            <v-time-picker
                    v-model="pickerTime"
                    color="primary"
                    :format="isBrowserLocale24h() ? '24hr' : 'ampm'"
                    :landscape="true"
                    @click:minute="minuteClicked"
            ></v-time-picker>
        </v-menu>
    </title-card>

</template>

<script>

    import moment from 'moment';
    import {timeDisplay} from '../mixins/timeDisplayMixin';
    import TitleCard from "./TitleCard";
    import DatePickerField from "./DatePickerField";

    export default {

        mixins: [timeDisplay],

        components: {
            TitleCard,
            DatePickerField
        },

        props: {
            timestamp: {
                type: String | null,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: true
            },
            color: {
                type: String,
                required: false,
                default: 'grey darken-3'
            },
            errorMessages: {
                type: Array,
                required: false
            },
            disableTime: {
                type: Boolean,
                required: false,
                default: false
            },
            min: {
                type: String,
                required: false,
                default: null,
            },
            max: {
                type: String,
                required: false,
                default: null,
            },
            help: {
                type: String,
                required: false,
                default: null,
            }
        },

        data() {
            return {
                debug: false,
                timeMenuOpen: false,
                pickerDate: null,
                pickerTime: null,
            }
        },

        computed: {
            computedDate() {
                if (this.pickerDate) {
                    return this.formatDate(this.pickerDate);
                }
            },
            computedTime() {
                if (this.pickerDate && this.pickerTime) {
                    return this.formatTime(this.pickerDate + ' ' + this.pickerTime);
                }
            },
        },

        watch: {
            timestamp: function (timestamp) {
                if (timestamp) {
                    this.pickerDate = moment.utc(timestamp).local().format('YYYY-MM-DD');
                    this.pickerTime = moment.utc(timestamp).local().format('HH:mm');
                }
            }
        },

        mounted() {
            if (this.timestamp) {
                this.pickerDate = moment.utc(this.timestamp).local().format('YYYY-MM-DD');
                this.pickerTime = moment.utc(this.timestamp).local().format('HH:mm');
            }
        },

        methods: {

            minuteClicked() {
                this.$refs.timeMenu.save(this.pickerTime);
                this.timeMenuOpen = false;
                this.emit();
            },

            saveDate(date) {
                this.pickerDate = date;
                this.emit();
            },

            emit() {
                this.$emit("changed", this.toUTC(this.pickerDate + " " + this.pickerTime));
            }
        }
    }
</script>
